/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetEventsQuery,
  IGetEventsQueryVariables,
  GetEventsDocument,
} from './types';
import { IEventsEventConnection } from '@r-client/data/graphql-types';
export type { IEventsEventConnection };

export type IGetEventsQueryOpts = IQueryModelOpts<IGetEventsQueryVariables>;

export class GetEventsQuery extends BaseQueryModel<
  IGetEventsQuery,
  IGetEventsQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetEventsQueryOpts) {
    super(opts);
  }

  get query() {
    return GetEventsDocument;
  }
}
export function useGetEventsQuery(opts?: Omit<IGetEventsQueryOpts, 'client'>) {
  const client = useGqlClient();
  return useQuery(
    () => new GetEventsQuery({ ...opts, client }),
    opts?.variables
  );
}
